import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss";
import { Icons, Images } from '../../../../assets';
import TableWrapper from '../../../../component/TableWrapper';
import { useNavigate } from 'react-router-dom';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';
import { Toast } from '../../../../service/toast';
import ConfirmationModal from '../../../../modalComponents/ConfirmationModal';

const UserRetailRequest = (props) => {

    const { activeTab, searchInput, setViewData } = props
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const [userList, setUserList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const [showDeletePopUp, setShowDeletePopUp] = useState(false)
    const [selectedId, setSelectedId] = useState(null)
    const [selectedRoleId, setSelectedRoleId] = useState(null)
    const [totalCount, setTotalCount] = useState(null)
    const navigate = useNavigate()

    const userHeader = [
        { label: 'S.No'},
        { label: 'User Name', sortable: 'username' },
        { label: 'Email', sortable: 'email' },
        { label: 'Company Name', sortable: 'legal_name' },
        { label: 'Role' },
        // { label: 'Membership' },
        { label: 'Date Joined' },
        ...(activeTab?.type === 'completed_mechanics' ? [{ label: 'Status' }] : []),
        ...(activeTab?.type === 'completed_mechanics' ? [] : [{ label: 'Membership' }]),
        { label: 'Actions' },
    ];

    useEffect(() => {
        setPage(1)
        setSortConfig(null)
    }, [activeTab])

    useEffect(() => {
        getUserList()
    }, [page, activeTab, searchInput, sortConfig])

    const getUserList = async () => {
        setisLoading(true)
        let url = `${Exported.Endpoints.getManageUsers}`
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (activeTab?.role) {
            paramsObj['role'] = activeTab?.role
        }
        if (activeTab?.type) {
            paramsObj['type'] = activeTab?.type
        }
        if (activeTab?.isApprovedByFilter) {
            paramsObj['isApprovedByFilter'] = activeTab?.isApprovedByFilter
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        if (sortConfig) {
            paramsObj['sort'] = sortConfig?.key
            paramsObj['sortOrder'] = sortConfig?.direction
        }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setUserList(obj)
                setTotalCount(res?.data?.data?.pageMeta?.total)
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        setisLoading(false)
    }

    const redirectUserDetails = (id, item) => {
        // setViewData(item)
        navigate(`?id=${id}`)
    }

    const downloadActivity = async (id, item) => {
        let url = Exported.Endpoints.scannedActivity;
    
        let paramsObj = {
            page: page,
            limit: 10,
            export_excel: true,
            userId: id,
        };
    
        await request({
            url: url,
            method: Exported.APIMethods.GET,
            params: { ...paramsObj },
            responseType: 'arraybuffer',  
        })
            .then((res) => {
                if (res?.data && res?.data) {
                    const blob = new Blob([res?.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });  
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = `${item.username}_activity.xlsx`;  
                    link.click(); 
                    window.URL.revokeObjectURL(downloadUrl);
                } else {
                    Toast({
                        type: 'error',
                        message: 'Invalid file data.',
                    });
                }
            })
            .catch((err) => {
                console.log(err, 'err');
                Toast({
                    type: 'error',
                    message: 'Unable to process the request!..',
                });
            });
    };
    

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const handleStatus = (keyValue, defaultValue, className = '', color) => {
      return (
          <td className={`${className}`} style={{color:`${color}`}}>{keyValue ? keyValue : defaultValue}</td>
      )
  };

    const handleDelete = (id, roleId) => {
        setShowDeletePopUp(true)
        setSelectedId(id)
        setSelectedRoleId(roleId)
    }
    const deleteProduct = async () => {
        dispatch(saveLoadingState(true))
        let url = `${Exported.Endpoints.common}/${selectedId}`
        const requestData = {
            id: selectedId,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then(async (res) => {
            if (res?.data?.status) {
                await getUserList()
                setShowDeletePopUp(false)
                Toast({
                    type: 'success',
                    message: 'Record deleted successfully!...'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        dispatch(saveLoadingState(false))
    }

    const handleClose = () => {
        setShowDeletePopUp(false)
    }

    return (
      <div className={`eventWrapper`}>
        <div className="countContainer">
            <p>Total Count: {totalCount}</p>
        </div>
        <div className={`mt-2 mb-5 ${classes.retailTableWrapper}`}>
          <TableWrapper
            headerDetails={userHeader}
            pageMeta={userList?.pageMeta}
            handlePageChange={setPage}
            listLength={userList?.result || []}
            isLoading={isLoading}
            sortConfig={sortConfig}
            setSortConfig={setSortConfig}
          >
            {userList?.result?.map((item, index) => {
              const {
                username = "",
                email = "",
                businessInfo = {},
                userRole = "",
                membershipPlan = "",
                id = "",
                roleId = "",
                createdAt = "",
                approvedByAdmin=""
              } = item;
              return (
                <tr key={`${id}-${index}`}>
                  {handleData(
                    (page - 1) * 10 + (index + 1),
                    "-",
                    "text-center"
                  )}
                  {handleData(username, "-", "text-center")}
                  {handleData(email, "-", "text-center")}
                  {handleData(businessInfo?.legal_name, "-", "text-center")}
                  {handleData(userRole, "-", "text-center")}
                  {handleData(
                    createdAt
                      ? new Date(createdAt).toLocaleDateString("en-GB")
                      : "-",
                      "-",
                      "text-center"
                    )}
                  { activeTab?.type !== "completed_mechanics" && handleData(membershipPlan, "-", "text-center")}
                  {activeTab?.type === "completed_mechanics" &&
                    handleStatus(
                      approvedByAdmin === null
                        ? "Pending"
                        : approvedByAdmin === true
                        ? "Approved"
                        : "Rejected",
                      "-",
                      `text-center`,
                       `${
                        approvedByAdmin === null
                          ? "orange"
                          : approvedByAdmin === true
                          ? "green"
                          : "red"
                      }`
                    )}
                  <td className=" px-3 mx-auto text-center action-button">
                    <div className="flex items-center justify-center">
                      <img
                        src={Icons.eye}
                        alt="View"
                        className="cursor-pointer w-[20px] h-[20px]"
                        onClick={() => redirectUserDetails(id, item)}
                      />
                      {activeTab?.role !== 2 && activeTab?.role !== 3 ? (
                        <img
                          src={Icons.downloadIcon}
                          alt="download"
                          className="cursor-pointer w-[20px] h-[20px] ml-3"
                          onClick={() => downloadActivity(id, item)}
                        />
                      ) : null}
                      {activeTab?.role !== 2 && activeTab?.role !== 3 ? (
                        <img
                          src={Icons.delete}
                          alt="delete"
                          className="cursor-pointer w-[20px] h-[20px] ml-3"
                          onClick={() => handleDelete(id, roleId)}
                        />
                      ) : null}
                    </div>
                  </td>
                </tr>
              );
            })}
          </TableWrapper>
        </div>
        {showDeletePopUp ? (
          <ConfirmationModal
            isOpen={showDeletePopUp}
            handleSuccess={deleteProduct}
            closePopUp={handleClose}
            warningText={"Confirmation"}
            modalText={
              selectedRoleId === 2
                ? "If this Retailer is deleted, all the Authorized Users associated with this Retailer will be deleted."
                : "Are you sure you want to delete this user?"
            }
            confirmText={"Yes"}
            cancelText={"No"}
            primaryBtnConfirm={false}
          />
        ) : null}
      </div>
    );
}

export default UserRetailRequest